import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {getUploadUrl} from "../../../../../utils/baseUrl";
import useWindowDimensions from "../../../../../hook/useWindowDimension";
import type1 from "../../../../../assets/icons/sheetsCategory/type1.svg";
import type2 from "../../../../../assets/icons/sheetsCategory/type2.svg";
import type3 from "../../../../../assets/icons/sheetsCategory/type3.svg";
import type4 from "../../../../../assets/icons/sheetsCategory/type4.svg";
import type5 from "../../../../../assets/icons/sheetsCategory/type5.svg";
import type6 from "../../../../../assets/icons/sheetsCategory/type6.svg";
import type7 from "../../../../../assets/icons/sheetsCategory/type7.svg";
import type8 from "../../../../../assets/icons/sheetsCategory/type9.svg";
import type9 from "../../../../../assets/icons/sheetsCategory/type8.svg";
import glasses from "../../../../../assets/icons/glasses.svg";
import row from "../../../../../assets/icons/theme.svg";

const Sheets = ({
                    sheetsList,
                    firstsSheetsOfArray,
                    setSheetsVideosModalButton,
                    showSheetsAccueil,
                    handleOpenNavItem,
                    navItem
                }) => {
    const {width} = useWindowDimensions();
    const [themesActive, setThemeActive] = useState(false);
    const [filteredSheets, setFilteredSheets] = useState([]);
    const [noSheetMessage, setNoSheetMessage] = useState(false);
    useEffect(() =>
            setSheetsVideosModalButton(false),
        []);
    const sheetsTypeArray = [
        {index: 1, src: type1, title: "Aides financières"},
        {index: 2, src: type2, title: "Juridique"},
        {index: 3, src: type3, title: "Prévention"},
        {index: 4, src: type4, title: "Assistance"},
        {index: 5, src: type5, title: "Solutions d'hébergement"},
        {index: 6, src: type6, title: "Fragilités"},
        {index: 7, src: type7, title: "Parentalité"},
        {index: 8, src: type8, title: "Equilibre Personnel"},
        {index: 9, src: type9, title: "Lexique"},
        {index: 10, title: "Toutes les fiches"},
    ];
    const [type, setType] = useState();

    return (
        <> {navItem !== "pepiteInfos-fichesPratiques"
            ?
            <>
                <div>
                    <h3><img src={glasses}/>Les fiches pratiques</h3>
                    <p onClick={() => {
                        const title = "pepiteInfos-fichesPratiques";
                        handleOpenNavItem(title);
                    }} className={"voirTout"}>Voir tout</p>
                </div>
                <ul className={"mobile-list-container-ul horizontal-scroll list-cases"}
                    id={"sheets"}>
                    {showSheetsAccueil
                        ? <h1 id={"mobile"}>Un peu de lecture</h1>
                        : <h1 id={"mobile"}>Les fiches pratiques</h1>
                    }
                    {sheetsList &&
                        // ici on affiche juste les trois première fiches pratiques
                        sheetsList.map((sheet, index) => {
                            if (index < 4)
                                return (
                                    <li key={sheet.id} onClick={() =>
                                        window.open(
                                            `${getUploadUrl()}/fiches/${sheet.urlPdf}`,
                                            "_blank"
                                        )
                                    }>
                                        <div className={"iconeSheetType"}>
                                            {sheetsTypeArray.map((sheetType, index) => {
                                                // console.log(sheet.titre, sheet.type, sheetType, sheetType.src);
                                                if (sheetType.index == sheet.type) {
                                                    return <img src={sheetType.src} key={index}/>;
                                                }
                                            })
                                            }
                                        </div>
                                        <div
                                            className={"list-elements-main-img"}
                                            style={{
                                                backgroundImage: `url(${getUploadUrl()}/fiches/pic/${
                                                    sheet.id
                                                }.jpeg`,
                                                width: "17,43vw",
                                                height: "70%",
                                                borderRadius: "4px",
                                                marginBottom: "1vh",
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                            }}
                                        />
                                        <h1>{sheet.titre}</h1>
                                    </li>
                                );
                        })}
                </ul>
            </>
            : <ul>
                {sheetsList.map((sheet, index) => {
                    return (
                        <>
                            {index == 0 &&
                                <>
                                    <h3 className={"theme-title"}
                                        onClick={() => setThemeActive(!themesActive)}>Fiches par{width > 599 &&
                                        <br/>} thème
                                        <img
                                            src={row}
                                            className={themesActive ? "active" : "disabled"}
                                        />
                                    </h3>
                                    {noSheetMessage &&
                                        <p className={"filteredSheetsEmpty"}>Oups ! Il n&apos;existe aucune fiche
                                            pratique dans le thème
                                            sélectionné.<br/>Choisissez-en un autre !</p>}
                                    {themesActive &&
                                        <ul className={"theme-ul"}>
                                            {sheetsTypeArray.map((sheetType) => {
                                                return (
                                                    <li key={sheetType.index}
                                                        className={"theme-ul-li"}
                                                        onClick={() => {
                                                            if (sheetType.index == 10) setFilteredSheets(sheetsList);
                                                            else {
                                                                const array = sheetsList.filter((sheet) => sheet.type == sheetType.index);
                                                                setFilteredSheets(array);
                                                                console.log("testarray", array);
                                                                if (array.length == 0) setNoSheetMessage(true);
                                                                else setNoSheetMessage(false);
                                                            }
                                                            setThemeActive(false);
                                                        }
                                                        }
                                                    >
                                                        <img src={sheetType.src}/>
                                                        <h3
                                                            style={{fontWeight: sheetType.index == 10 ? "500" : "300"}}
                                                        >{sheetType.title}</h3>
                                                    </li>
                                                );
                                            })
                                            }
                                        </ul>
                                    }
                                </>
                            }
                            {filteredSheets.length == 0
                                && <li key={sheet.id}
                                       onClick={() => {
                                           window.open(
                                               `${getUploadUrl()}/fiches/${sheet.urlPdf}`,
                                               "_blank"
                                           );
                                       }}
                                       className={((index == 0) && (width > 599)) ? "firstSheet" : ""}
                                       id={(index == 0 && width > 599) ? "" : "fiches-pratiques-page-ul-li"}
                                    // si un filtre est actif et que ce n'est pas la première sheet de la liste, on affiche pas pour laisser place aux fiches filtrées
                                       style={{
                                           display:
                                               ((filteredSheets.length == 0) || ((filteredSheets.length !== 0) && (index == 0)))
                                                   ? "initial"
                                                   : "none"
                                       }}
                                >
                                    <div className={"iconeSheetType"}>
                                        {/*On map le tableau qui contient toutes les données des filtres, et on compare leur index avec celui des sheet affichées.
                                    Si c'est le même, on retourne l'icône avec l'url correspondante*/}
                                        {sheetsTypeArray.map((sheetType, index) => {
                                            if (sheetType.index == sheet.type) {
                                                return <img src={sheetType.src} key={index}/>;
                                            }
                                        })
                                        }
                                    </div>
                                    <div
                                        className={"list-elements-main-img"}
                                        style={{
                                            backgroundImage: `url(${getUploadUrl()}/fiches/pic/${
                                                sheet.id
                                            }.jpeg`,
                                            width: "17,43vw",
                                            height: width > 599
                                                ? index == 0
                                                    ? "78%"
                                                    : "70%"
                                                : "66%",
                                            borderRadius: "4px",
                                            marginBottom: "1vh",
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                        }}
                                    />
                                    <h1>{sheet.titre}</h1>
                                </li>
                            }
                        </>
                    );
                })
                }
                {filteredSheets.map((sheet, index) => {
                    console.log("filteredSheets", filteredSheets);
                    return (
                        <li key={sheet.index}
                            className={(index == 0 && width > 599) ? "theme-ul-li firstSheet" : "theme-ul-li"}
                            onClick={() => {
                                window.open(
                                    `${getUploadUrl()}/fiches/${sheet.urlPdf}`,
                                    "_blank"
                                );
                            }}
                        >
                            <div className={"iconeSheetType"}>
                                {sheetsTypeArray.map((sheetType, index) => {
                                    // console.log(sheet.titre, sheet.type, sheetType, sheetType.src);
                                    if (sheetType.index == sheet.type) {
                                        return <img src={sheetType.src} key={index}/>;
                                    }
                                })
                                }
                            </div>
                            <div
                                className={"list-elements-main-img"}
                                style={{
                                    backgroundImage: `url(${getUploadUrl()}/fiches/pic/${
                                        sheet.id
                                    }.jpeg`,
                                    width: "17,43vw",
                                    height: width > 599
                                        ? index == 0
                                            ? "78%"
                                            : "70%"
                                        : "66%",
                                    borderRadius: "4px",
                                    marginBottom: "1vh",
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                }}
                            />
                            <h1>{sheet.titre}</h1>
                        </li>
                    );
                })}

            </ul>
        }
        </>
    );
};

Sheets.propTypes = {
    sheetsList: PropTypes.array,
    firstsSheetsOfArray: PropTypes.array,
    setSheetsVideosModalButton: PropTypes.func,
    setClassname: PropTypes.func,
    setShowSheetsAccueil: PropTypes.func,
    showSheetsAccueil: PropTypes.bool,
    setCasesRedirection: PropTypes.func,
    setShowOfferModal: PropTypes.func,
    setDisplayQuestions: PropTypes.func,
    setSelectedItem: PropTypes.func,
    handleOpenNavItem: PropTypes.func,
    navItem: PropTypes.string
};

export default Sheets;
